import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { backgroundColors, fontColors } from '@sphereon/ui-components.core';
const ComboBox = (props) => {
    const { onChange, noOptionsMessage, placeholder, defaultValue, inlineOption, options = [] } = props;
    const [value, setValue] = React.useState(props.value);
    const creatableProps = inlineOption
        ? {
            allowCreateWhileLoading: true,
            isValidNewOption: () => true,
            onCreateOption: inlineOption.onCreate,
            createOptionPosition: 'last',
            formatCreateLabel: () => `${inlineOption.caption}`,
        }
        : {};
    const onValueChange = async (newValue) => {
        setValue(newValue);
        await onChange?.(newValue);
    };
    return (_jsx(CreatableSelect, { menuPortalTarget: document.querySelector('body'), styles: {
            control: (provided, state) => ({
                ...provided,
                maxWidth: 455,
                borderColor: state.isFocused ? '#7276F7' : provided.borderColor,
                '&:hover': {
                    borderColor: '#7276F7',
                },
                boxShadow: 'none',
                height: 48,
                backgroundColor: backgroundColors.primaryLight,
            }),
            menu: (provided) => ({
                ...provided,
                maxWidth: 455,
            }),
            option: (provided, state) => ({
                ...provided,
                color: 'rgba(17, 17, 19, 0.60)',
                backgroundColor: state.isSelected ? '#7B61FF' : state.isFocused ? '#B7B8D9' : backgroundColors.primaryLight,
                '&:hover': {
                    backgroundColor: '#B7B8D9',
                },
            }),
            singleValue: (provided) => ({
                ...provided,
                color: fontColors.dark,
            }),
        }, defaultValue: defaultValue, onChange: onValueChange, value: value, options: options, placeholder: placeholder, noOptionsMessage: noOptionsMessage ? () => noOptionsMessage : undefined, maxMenuHeight: 210, ...creatableProps }));
};
export default ComboBox;
